<script setup lang="ts">
  import { TypoVariant } from '@travelata-libs/ui-kit';
  import { type SearchCriteriaHistory } from '@/entities/searchCriteria';
  import MobilePageHeader from '@/shared/ui/MobilePageHeader.vue';
  import MobileScreen from '@/shared/ui/MobileScreen.vue';
  import MobileHistoryCard from './MobileHistoryCard.vue';
  import { SEARCH_HISTORY_TEXTS } from '../config/texts';

  interface MobileHistoryScreenProps {
    items?: SearchCriteriaHistory[];
    embedded?: boolean;
    onBack: () => void;
  }

  withDefaults(defineProps<MobileHistoryScreenProps>(), {
    items: () => [],
    embedded: false,
  });

  const texts = SEARCH_HISTORY_TEXTS;
</script>

<template>
  <MobileScreen
    name="mobile-history-screen"
    testid="search-form-mobile-history"
    :embedded="embedded"
  >
    <MobilePageHeader
      class="mobile-history-screen__header"
      :title="texts.title"
      :title-variant="TypoVariant.Heading6"
      @back="onBack"
    />

    <div class="mobile-history-screen__body">
      <MobileHistoryCard
        v-for="(item, index) in items"
        :key="index"
        class="mobile-history-screen__card"
        :history-search="item"
      />
    </div>
  </MobileScreen>
</template>

<style scoped lang="scss">
  .mobile-history-screen {
    background: var(--color-slate-10);

    &__header {
      flex: 0 0 auto;
      padding: var(--spacing-s) var(--spacing-m) var(--spacing-xs) var(--spacing-m);
    }

    &__body {
      box-sizing: border-box;
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      gap: var(--spacing-s);
      overflow-y: auto;
      padding: var(--spacing-xs) var(--spacing-m) var(--spacing-m);
    }
  }
</style>
